import { cartConstants } from "../../../constants/cartConstants";

export default function reducer(state, action) {
    const  { cart }   = state
    const item = action.payload

    switch (action.type) {
        case cartConstants.ADD:
            if (cart.has(item.id)) {
                return { cart }
            }
            cart.set(item.id, item)
            return { cart }
        case cartConstants.ADD_DETAILS:
            if (!cart.has(item.id)) {
                return { cart }
            }
            const currentItem = cart.get(item.id)
            currentItem.details = item.details
            cart.set(item.id, currentItem)
            return { cart }
        case cartConstants.EDIT_DETAIL:
            if (!cart.has(item.id)) {
                return { cart }
            }

            const oldItem = cart.get(item.id)
            const details = oldItem.details
            details.forEach((detail) => {
                if (detail.part !== item.part) {
                    return
                }
                detail.qty = item.qty
            })

            oldItem.details = details
            cart.set(item.id, oldItem)
            return { cart }
        case cartConstants.EDIT_DETAIL_VENDOR_IDENTIFIER:
            if (!cart.has(item.id)) {
                return { cart }
            }

            const itemToUpdate = cart.get(item.id)
            itemToUpdate.details.forEach((detail) => {
                if (detail.part !== item.part) {
                    return
                }
                detail.vendorIdentifier = item.vendorIdentifier
            })

            cart.set(item.id, itemToUpdate)
            return { cart }
        case cartConstants.REMOVE_DETAIL:
            if (!cart.has(item.id)) {
                return { cart }
            }
            const BeforeRemoveItem = cart.get(item.id)
            const newDetails = BeforeRemoveItem.details.filter((row) => row.part !== item.part)
            BeforeRemoveItem.details = newDetails
            cart.set(item.id, BeforeRemoveItem)
            return { cart }
        case cartConstants.ADD_DETAIL:
            const { detail, features } = item
            if (!cart.has(detail.projectId)) {
                cart.set(detail.projectId, {
                    id: detail.projectId,
                    projectNumber: detail.projectNo,
                    vendor: detail.vendor,
                    vendorId: detail.vendorId,
                    projectCustomerId: detail.projectCustomerId,
                    client: detail.client,
                    details: [],
                    features,
                    fetchData: 0
                })
            }

            const projectFromCart = cart.get(detail.projectId)
            const oldProjectDetail = projectFromCart.details

            const found = oldProjectDetail.filter((row) => row.detailsId === detail.detailsId)

            if (found.length) {
                return { cart }
            }

            projectFromCart.details.push(detail)
            cart.set(detail.projectId, projectFromCart)

            return { cart }
        case cartConstants.REMOVE:
            if (!cart.has(item.id)) {
                return { cart }
            }
            cart.delete(item.id)
            return  { cart }
        case cartConstants.CLEAR:
            cart.clear()
            return { cart }
        case cartConstants.EDIT_PROJECT_FEATURE:
            const projectId = item.id
            const feature = item.feature

            if (!cart.has(projectId)) {
                return { cart }
            }
            const project = cart.get(item.id)

            if(!project.features) {
                return { cart }
            }

            project.features.forEach(oldFeature => {
                if (oldFeature.id === feature.id) {
                    oldFeature.featurePartnerValue = feature.featurePartnerValue
                }
            })

            cart.set(projectId, project)
            return  { cart }
        default:
            return { cart }
    }
}
